import styles from "./progressBar.module.css";
import ProgressBarIcon from "./progressBarIcon.svg?react";

export const ProgressBarLayout = () => {
    return (
        <>
            <div className={styles.progressBarLogo}>
                <ProgressBarIcon />
            </div>

            <div className={styles.progressBarInner}>
                <div className={styles.progressBarInnerFiller}></div>
            </div>
        </>
    );
};
